<section class="delete-account">
    <div class="container">
        <h2>Are you sure you want to delete your account?</h2>
        <p>Your session will be closed, your account and all your data will be deleted.</p>
        <div class="btns">
            <button class="btn-gennius">Cancel</button>
            <button class="btn-gennius active">Delete account</button>
        </div>
    </div>
</section>

<section class="delete-account">
    <div class="container">
        <h2>Your account has been deleted</h2>
        <p>Thank you for using Miles</p>
        <div class="btns">
            <button class="btn-gennius active">Go to home</button>
        </div>
    </div>
</section>